<script>
import Success from '@/views/succezz/facade.vue';
import Thanks from '@/views/succezz/thanks-template';
import common from '@/views/succezz/mixin/common';
import GetStarted from '@/views/succezz/thanks-template/get-started.vue';

export default {
  name: "DeskPhones",
  mixins: [common],
  components: {
    Success,
    GetStarted,
    Thanks
  },
}
</script>

<template>
<success :show-promotes="false">
  <thanks :email='email' :title='title' :confirm-sub-title='$t("billing.hw.desk_phones.success.confirm_sub_title", { email })'>
    <template #subtitle>
      <p class="opc-success__content-subtitle-desc" v-html="$t('billing.hw.desk_phones.success.confirm_sub_title_2')">
      </p>
      <p class="opc-success__content-subtitle-desc" v-html="$t('billing.hw.desk_phones.success.confirm_sub_title_3')">
      </p>
    </template>
    <template>
      <get-started />
    </template>
  </thanks>
</success>
</template>

<style lang="scss">
.opc-success__content-subtitle-desc {
  color: #00053D;
  font-family: "Almaden Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  margin-top: 24px;
  .underline {
    text-decoration: underline;
  }
  b {
    font-weight: 600;
  }
}
.opc-succezz-thx__sub-title {
  b {
    font-weight: 600;
  }
}
</style>
